// https://webcake.co/object-properties-in-angular-2s-ngfor/
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'iterable'
})
export class IterablePipe implements PipeTransform {
    public transform(value: any, args?: any[]): any[] {
        let keys: any[];
        let data: any[];
        try {
            (keys = Object.keys(value)), (data = []);
        } catch (_error) {
            return [];
        }

        if (!keys.length) {
            return value;
        }

        // Dumb check for enum
        if (
            typeof +keys[keys.length - 1] === 'number' &&
            typeof keys[0] === 'string' &&
            keys.length % 2 === 0
        ) {
            // Special case for 2 valued enums with -1 and 1.
            if (keys.length === 4 && keys[0] === '1' && keys[3] === '-1') {
                keys = keys.filter((x) => x !== '-1' && x !== '1');
            } else {
                keys = keys.slice(keys.length / 2);
            }
        }

        if (
            typeof +keys[keys.length - 1] === 'string' &&
            typeof keys[0] === 'number' &&
            keys.length % 2 === 0
        ) {
            keys = keys.slice(0, keys.length / 2);
        }

        data = keys.map((key) => ({
            key: key,
            label: key,
            value: value[key]
        }));

        data.sort((a, b): number => a.value - b.value);

        return data;
    }
}
